
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { ChatSection } from "./ChatSection";
import { CalendarEvent } from "@/types/calendar";
import { Message } from "./types";
import React from "react";

interface AIAssistantTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  chatProps: {
    messages: Message[];
    onSendMessage: (msg: string) => void;
    isProcessing: boolean;
    event?: CalendarEvent;
  };
  event?: CalendarEvent;
}

export const AIAssistantTabs = ({
  activeTab,
  setActiveTab,
  chatProps,
  event,
}: AIAssistantTabsProps) => {
  return (
    <Tabs
      value={activeTab}
      onValueChange={setActiveTab}
      className="flex-1 flex flex-col h-full"
    >
      <TabsContent
        value="chat"
        className="flex-1 flex flex-col p-0 mt-0 data-[state=active]:flex-1 h-full"
      >
        <ChatSection {...chatProps} />
      </TabsContent>
    </Tabs>
  );
};
